import styled from "styled-components";

const StyledDashboard = styled.div`
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(82, 63, 105, 0.05);
  border-radius: 4px;
`;
export default StyledDashboard;
